import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { Optional } from 'utility-types';

import { ConfirmedButton, ConfirmedButtonProps } from '../confirmed-button';
import { AppColors } from '../../theme';

const useStyles = makeStyles(
  createStyles({
    button: {
      color: AppColors.LightBlue,
    },
  })
);

type Props = Optional<ConfirmedButtonProps, 'action'>;

export const ResendButton: React.FC<Props> = ({ className, ...props }) => {
  const styles = useStyles();

  return (
    <ConfirmedButton
      action="Resend"
      className={clsx(styles.button, className)}
      variant="outlined"
      {...props}
    />
  );
};
